import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { Typography, makeStyles, ConfirmationDialog } from "componentLibrary";
import TextField from "components/mui/Fields/Fields/TextField/TextField";
import MuiFormikField from "dashboard/Invoicing/common/MuiFormikField";
import DragDropSortableFields from "./DragDropSortableFields";
import DropdownOptionRow from "componentLibrary/CustomizeColumns/DropdownOptionRow";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    dropdownContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "16px"
    },
    rowContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      alignItems: "center"
    },
    iconContainer: {
      display: "flex",
      gap: "8px"
    }
  };
});
var CustomDropdown = function CustomDropdown(_ref) {
  var values = _valuesInstanceProperty(_ref),
    setValues = _ref.setValues,
    handleChange = _ref.handleChange,
    handleDragableChange = _ref.handleDragableChange,
    labelSpacing = _ref.labelSpacing,
    errors = _ref.errors,
    setErrors = _ref.setErrors;
  var classes = useStyles();
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    deletingOption = _React$useState2[0],
    setDeletingOption = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isEditing = _React$useState4[0],
    setIsEditing = _React$useState4[1];
  var hasDuplicateName = function hasDuplicateName(fieldName, excludeIndex) {
    var _context;
    if (!fieldName || !(fieldName !== null && fieldName !== void 0 && _trimInstanceProperty(fieldName).call(fieldName))) return false;
    var normalizedInput = fieldName === null || fieldName === void 0 ? void 0 : _trimInstanceProperty(fieldName).call(fieldName);
    return _someInstanceProperty(_context = values.dropdownOptions).call(_context, function (option, index) {
      return index !== excludeIndex && (option === null || option === void 0 ? void 0 : option.label) === normalizedInput;
    });
  };
  var handleAddOption = function handleAddOption(newVal) {
    var _context2;
    if (!newVal || (newVal === null || newVal === void 0 ? void 0 : _trimInstanceProperty(newVal).call(newVal)) === "") return;
    if (hasDuplicateName(newVal)) {
      setErrors === null || setErrors === void 0 || setErrors({
        newDropdownOption: "This name already exists"
      });
      return;
    }
    setValues(_objectSpread(_objectSpread({}, values), {}, {
      dropdownOptions: _concatInstanceProperty(_context2 = [{
        isDisabled: false,
        isRemovable: false,
        label: newVal,
        name: newVal
      }]).call(_context2, _toConsumableArray(values.dropdownOptions)),
      newDropdownOption: ""
    }));
    setErrors === null || setErrors === void 0 || setErrors({
      newDropdownOption: null
    });
  };
  var handleKeyDown = function handleKeyDown(e) {
    var _values$newDropdownOp;
    e.stopPropagation();
    if ((values === null || values === void 0 || (_values$newDropdownOp = values.newDropdownOption) === null || _values$newDropdownOp === void 0 ? void 0 : _trimInstanceProperty(_values$newDropdownOp).call(_values$newDropdownOp)) === "") {
      return null;
    }
    if (e.key === "Enter") {
      var _values$newDropdownOp2;
      e.preventDefault();
      handleAddOption(values === null || values === void 0 || (_values$newDropdownOp2 = values.newDropdownOption) === null || _values$newDropdownOp2 === void 0 ? void 0 : _trimInstanceProperty(_values$newDropdownOp2).call(_values$newDropdownOp2));
      return false;
    }
    setErrors === null || setErrors === void 0 || setErrors({
      newDropdownOption: null
    });
    return null;
  };
  var handleDeleteOption = function handleDeleteOption(item) {
    var _values$dropdownOptio, _values$dropdownOptio2;
    var updatedOptions = (_values$dropdownOptio = values.dropdownOptions) === null || _values$dropdownOptio === void 0 ? void 0 : _filterInstanceProperty(_values$dropdownOptio).call(_values$dropdownOptio, function (option) {
      return option.name !== (item === null || item === void 0 ? void 0 : item.name);
    });
    var deletedIndex = (_values$dropdownOptio2 = values.dropdownOptions) === null || _values$dropdownOptio2 === void 0 ? void 0 : _findIndexInstanceProperty(_values$dropdownOptio2).call(_values$dropdownOptio2, function (option) {
      return option.name === (item === null || item === void 0 ? void 0 : item.name);
    });
    setErrors === null || setErrors === void 0 || setErrors({
      dropdownOptions: _defineProperty({}, deletedIndex, null)
    });
    setValues(_objectSpread(_objectSpread({}, values), {}, {
      dropdownOptions: updatedOptions
    }));
    setDeletingOption(null);
  };
  var handleSaveOption = function handleSaveOption(index, newLabel) {
    var _values$dropdownOptio3;
    var updatedOptions = (_values$dropdownOptio3 = values.dropdownOptions) === null || _values$dropdownOptio3 === void 0 ? void 0 : _mapInstanceProperty(_values$dropdownOptio3).call(_values$dropdownOptio3, function (option, i) {
      return i === index ? _objectSpread(_objectSpread({}, option), {}, {
        label: newLabel,
        name: newLabel
      }) : option;
    });
    setValues(_objectSpread(_objectSpread({}, values), {}, {
      dropdownOptions: updatedOptions
    }));
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: labelSpacing,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_small",
        weight: "medium",
        children: "Dropdown Options"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.dropdownContainer,
      children: [/*#__PURE__*/_jsx(MuiFormikField, {
        Component: TextField,
        defaultValue: values === null || values === void 0 ? void 0 : values.newDropdownOption,
        name: "newDropdownOption",
        placeholder: "Type your option and press Enter",
        fullWidth: true,
        onChange: handleChange,
        editMode: true,
        disabled: isEditing !== false,
        size: "small",
        onKeyDown: handleKeyDown
      }), /*#__PURE__*/_jsx(DragDropSortableFields, {
        disabled: isEditing !== false,
        data: values === null || values === void 0 ? void 0 : values.dropdownOptions,
        onChange: handleDragableChange,
        name: "dropdownOptions",
        useRedesign: true,
        renderRow: function renderRow(item, index) {
          return /*#__PURE__*/_jsx(DropdownOptionRow, {
            item: item,
            onDelete: function onDelete(item) {
              setDeletingOption(item);
              setErrors === null || setErrors === void 0 || setErrors({
                dropdownOptions: _defineProperty({}, index, null)
              });
              setIsEditing(false);
            },
            index: index,
            onSave: handleSaveOption,
            isDuplicate: hasDuplicateName,
            isEditing: isEditing,
            setIsEditing: setIsEditing,
            errors: errors,
            setErrors: setErrors
          });
        }
      })]
    }), !!deletingOption ? /*#__PURE__*/_jsx(ConfirmationDialog, {
      title: "Delete Column",
      bodyMessage: "You are about to delete the '".concat(deletingOption === null || deletingOption === void 0 ? void 0 : deletingOption.label, "' option. This action will permanently remove all data with this option and cannot be undone."),
      open: !!deletingOption,
      onClose: function onClose() {
        return setDeletingOption(null);
      },
      onCancel: function onCancel() {
        return setDeletingOption(null);
      },
      onConfirm: function onConfirm() {
        return handleDeleteOption(deletingOption);
      },
      disableCloseOnBackdropClick: true
    }) : null]
  });
};
export default CustomDropdown;